/**
 * RepeatButton
 * 
 * 职责：重复播放当前字幕按钮
 */

import React from 'react';

interface RepeatButtonProps {
  isActive: boolean;
  disabled: boolean;
  onClick: () => void;
}

export const RepeatButton: React.FC<RepeatButtonProps> = ({
  isActive,
  disabled,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  };

  return (
    <button
      className={`control-button repeat-button ${isActive ? 'active' : ''}`}
      disabled={disabled}
      onClick={handleClick}
      onTouchEnd={handleTouchEnd}
      aria-label={isActive ? '关闭重复' : '开启重复'}
      title={isActive ? '关闭重复播放当前字幕' : '重复播放当前字幕'}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"/>
      </svg>
    </button>
  );
};

